// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"567":"86cc0c5c","690":"127b438c"}[chunkId] + ".css";
};